<script setup>
import { swalError, swalSuccess } from '@/helper';
import { update_option } from '@/services/option';
import { create_option, get_option } from '@/services/option';
import { onMounted, ref } from 'vue';

const isLoading = ref(true)
onMounted(async()=>{
  await get_feedback_question()
  isLoading.value = false
})

const optionConfig = ref({})
const isNew = ref(false)
async function get_feedback_question(){
  let response = await get_option('feedback_question')
  // console.log("🚀 ~ get_feedback_question ~ response:", response)
  if (response.error){
    swalError(response.result, true)
    return
  }
  if (response.result.data){
    optionConfig.value = parseQuestion(response.result)
    questions.value = [...optionConfig.value.tempQuestions]
  }else{
    isNew.value = true
  }
}

function parseQuestion(result){
  let data = result.data
  let tempQuestions = result.included.map(item =>{
    return {
      id: item.id,
      title: item.attributes.key,
      type: item.attributes.value,
      _destroy: false
    }
  })
  return {data, tempQuestions}
}

const question = ref({})
const questions = ref([])
function addQuestion(){
  let temp = {...question.value, id: null, _destroy: false}
  question.value = {}
  questions.value.push(temp)
}

function createParams(){
  let params = {}
  if(isNew.value){
    params.name = 'feedback_question'
    params.config = 'feedback_question'
    params.option_type = 'feedback_question'
    params.option_meta_attributes = questions.value.map(item => {
      return {key: item.title, value: item.type}
    })
  }else{
    params.option_meta_attributes = questions.value.map(item => {
      return {id: item.id, key: item.title, value: item.type, _destroy: item._destroy}
    })
  }
  return params
}

async function saveQuestion(){
  let params = createParams()
  let response = ''
  if (isNew.value){
    response = await create_option(params)
  }else{
    response = await update_option(optionConfig.value.data.id, params)
  }
  if (response.error){
    swalError(response.result, true)
    return
  }
  swalSuccess('Feedback question has been saved')
  question.value = {title: '', type: ''}
}

function removeQuestion(ind){
  let item = questions.value[ind]
  if (item.id == null){
    questions.value.splice(ind, 1)
  }else{
    item._destroy = true
  }
}
</script>

<template>
  <div class="container-fluid">
    <Breadcrumbs main="Feedback Configuration"/>

    <div class="card">
      <CardHeader title="Questions"/>
      <div class="card-body">
        <form @submit.prevent="addQuestion()">
          <div class="row">
            <div class="col-md-10">
              <div class="mb-3">
                <label class="form-label" for="weight">Question Title</label>
                <input class="form-control" type="text"
                  placeholder="Question Title"
                  required
                  v-model="question.title"
                >
              </div>
            </div>
            <div class="col-md-10">
              <div class="mb-3">
                <label class="form-label" for="weight">Question Type</label>
                <select class="form-select" id="gender"
                  v-model="question.type"
                  required
                >
                  <option selected disabled value="">Select type</option>
                  <option value="choice">Yes & No</option>
                  <option value="input">Text Input</option>
                </select>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <button type="submit" class="btn btn-light-success">
              Add Question
            </button>
          </div>
        </form>
        <div>
          <h4>Question List</h4>
          <loadingCard v-if="isLoading"/>
          <template v-else>
            <template v-if="questions.length == 0">
              <p>No question has been added. Please add question using the form above</p>
            </template>
            <template v-else v-for="(ques, ind) in questions">
              <div v-if="!ques._destroy" class="card-body border rounded py-2 mb-2">
                <div class="row">
                  <div class="col-8">
                    <p class="mb-1">
                      <span class="fw-semibold">Title : </span>
                      {{ ques.title }}
                    </p>
                    <p>
                      <span class="fw-semibold">Type : </span>
                      {{ ques.type == 'choice' ? 'Yes & No' : 'Text Input'  }}
                    </p>
                  </div>
                  <div class="col-4 d-flex justify-content-center align-items-center">
                    <button type="button" @click="removeQuestion(ind)" class="btn btn-light-danger">
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            </template>
          </template>
          <div class="mt-2 d-flex justify-content-end">
            <button @click="saveQuestion()" type="button" class="btn btn-light-success">
              Update Question
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>